module.exports = __webpack_public_path__ + "img/nobuild.99fdf152.png";